import React from "react";
import { Card, Descriptions, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { format, parseISO } from "date-fns";

const DetailsCard = ({ data, setEditModalOpen }) => {
  return (
    <Card
      title={
        <span style={{ textTransform: "capitalize" }}>
          {data?.firstName} {data?.lastName}
        </span>
      }
      extra={
        <Button type="text" icon={<EditOutlined />} onClick={() => setEditModalOpen(true)} />
      }
      style={{ width: 280 }}
    >
      <Descriptions column={1} size="small">
        <Descriptions.Item label="Email">{data?.email || "--"}</Descriptions.Item>
        <Descriptions.Item label="Phone">{data?.phone || "--"}</Descriptions.Item>
        <Descriptions.Item label="DOB">
          {data?.dateOfBirth ? format(parseISO(data.dateOfBirth), "dd MMM yyyy") : "--"}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default DetailsCard;
